import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import {
  LimpiarPrestacion,
} from "../NuevaPrestacionForm/actions";
import {
  ErrorSnacktOpen,
} from "../../ErrorSnack/actions";
import replicarSolicitudReducer from "../ReplicarSolicitud/reducer";
import {
  nuevaSolicitud,
} from "../GrillaSolicitud/actions";
const download = require("downloadjs");
import axios from 'axios';

// //////////////////
// Action Creators //
// //////////////////

export const CambiarInicioVigencia = (inicioVigenciaPaquete, error) => ({
  type: "CAMBIAR_INICIO_VIGENCIA",
  inicioVigenciaPaquete,
  error,
});

export const filtroBusqueda = () => ({
  type: "FILTRO_BUSQUEDA",
});

export const cargarPaquetes = (paquetes) => ({
  type: "CARGAR_PAQUETES",
  paquetes,
});

export const cargarTiposAtencion = (tiposAtencion) => ({
  type: "CARGAR_TIPOS_ATENCION",
  tiposAtencion,
});

export const cargarNuevaPrestacion = (modalNuevaPrestacion) => ({
  type: "CARGAR_NUEVA_PRESTACION",
  modalNuevaPrestacion,
});

export const CambiarTipoAtencion = (tipoAtencion) => ({
  type: "CAMBIAR_TIPO_ATENCION",
  tipoAtencion,
});

export const CambiarTipoAtencion2 = (tipoAtencion2, tipoAtencion3) => ({
  type: "CAMBIAR_TIPO_ATENCION2",
  tipoAtencion2,
  tipoAtencion3,
});

export const CambiarTipoAtencion3 = (tipoAtencion3) => ({
  type: "CAMBIAR_TIPO_ATENCION3",
  tipoAtencion3,
});

export const CambiarVigencia = (vigencia) => ({
  type: "CAMBIAR_VIGENCIA",
  vigencia,
});

export const CambiarCodIntervencion = (codIntervencion) => ({
  type: "CAMBIAR_CODIGO_INTERVENCION",
  codIntervencion,
});

export const CambiarCodPaquetePres = (codPaquetePres) => ({
  type: "CAMBIAR_CODIGO_PAQUETE_PRESTADOR",
  codPaquetePres,
});

export const CambiarGlosa = (glosa) => ({
  type: "CAMBIAR_GLOSA_PAQUETE",
  glosa,
});

export const Loading = (loading) => ({
  type: "LOADING",
  loading,
});

export const LoadingExcel = (loadingExcel) => ({
  type: "LOADINGEXCEL",
  loadingExcel,
});

export const CargarSolicitudes = (solicitudes) => ({
  type: "CARGAR_SOLICITUDES",
  solicitudes,
});

export const OpenCargarBorrador = (modalAction) => ({
  type: "OPEN_CARGAR_BORRADOR",
  modalAction,
});

export const CargarDetalleSolicitud = (prestacionesSolicitud, idSolicitud) => ({
  type: "CARGAR_DETALLE_SOLICITUD_FIL",
  prestacionesSolicitud,
  idSolicitud,
});

export const SetSolicitudesEnCurso = (solicitudEnCurso, result) => ({
  type: "ACT_PAQUETE_SET_SOLICITUD_EN_CURSO",
  solicitudEnCurso,
  result,
});

export const cargarPaginacion = (paginacion) => ({
  type: "CARGAR_PAGINACION",
  paginacion,
});


// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const BuscarPaquetes = (value) => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaPQ.filtros;
  const globalState = store.getState().global;
  let FechaInicioVigencia;

  if (filtrosState.inicioVigenciaPaquete) {
    FechaInicioVigencia = filtrosState.inicioVigenciaPaquete.getFullYear() * 1e4 + (filtrosState.inicioVigenciaPaquete.getMonth() + 1) * 100 + filtrosState.inicioVigenciaPaquete.getDate() + '';
  }

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    CodigoIntervencion: filtrosState.codIntervencion,
    CodPaquetePres: filtrosState.codPaquetePres,
    Descripcion: filtrosState.glosa,
    Vigencia: filtrosState.vigencia,
    FiltrosBusqueda: filtrosState.tipoAtencion3,
    FechaInicioVigencia: FechaInicioVigencia,
    Isapre: globalState.isapre,
    pageNumber: 1,
    pageSize: 5,
    token: globalState.token,
  };
  //console.log("PARAMETROS ANTES DE AXIOS");
  //console.log(params);
  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/paquetes/prestaciones/`,
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    if (response.status === 200) {
      //console.log("RESPONSE OK");
      //console.log(response.data);

      if (Array.isArray(response.data)) {
        //trace.information("BuscarPaquetes", response.data);
        dispatch(cargarPaquetes(response.data));
        dispatch(Loading(false));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarPrestaciones", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });
};

export const BuscarPrestacionesPP = (pagina, totalPagina) => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaPQ.filtros;
  const globalState = store.getState().global;
  let FechaInicioVigencia;

  if (filtrosState.inicioVigenciaPaquete) {
    FechaInicioVigencia = filtrosState.inicioVigenciaPaquete.getFullYear() * 1e4 + (filtrosState.inicioVigenciaPaquete.getMonth() + 1) * 100 + filtrosState.inicioVigenciaPaquete.getDate() + '';
  }

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    CodigoIntervencion: filtrosState.codIntervencion,
    CodPaquetePres: filtrosState.codPaquetePres,
    Descripcion: filtrosState.glosa,
    Vigencia: filtrosState.vigencia,
    FiltrosBusqueda: filtrosState.tipoAtencion3,
    FechaInicioVigencia: FechaInicioVigencia,
    Isapre: globalState.isapre,
    pageNumber: pagina,
    pageSize: totalPagina,
    token: globalState.token,
  };
  //console.log("PARAMETROS ANTES DE AXIOS");
  //console.log(params);
  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/paquetes/prestaciones/`,
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    if (response.status === 200) {
      //console.log("RESPONSE OK");
      //console.log(response.data);

      if (Array.isArray(response.data)) {
        //trace.information("BuscarPaquetes", response.data);
        dispatch(cargarPaquetes(response.data));
        dispatch(Loading(false));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarPrestaciones", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });
};

export const BuscarTotalPaginas = (value) => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaPQ.filtros;
  const globalState = store.getState().global;
  let FechaInicioVigencia;

  if (filtrosState.inicioVigenciaPaquete) {
    FechaInicioVigencia = filtrosState.inicioVigenciaPaquete.getFullYear() * 1e4 + (filtrosState.inicioVigenciaPaquete.getMonth() + 1) * 100 + filtrosState.inicioVigenciaPaquete.getDate() + '';
  }

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    CodigoIntervencion: filtrosState.codIntervencion,
    CodPaquetePres: filtrosState.codPaquetePres,
    Descripcion: filtrosState.glosa,
    Vigencia: filtrosState.vigencia,
    FiltrosBusqueda: filtrosState.tipoAtencion3,
    FechaInicioVigencia: FechaInicioVigencia,
    Isapre: globalState.isapre,
    pageSize: 5,
    token: globalState.token,
  };
  //console.log("PARAMETROS ANTES DE AXIOS");
  //console.log(params);
  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/paquetes/total-registros/`,
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    if (response.status === 200) {
      //console.log("RESPONSE OK");
      //console.log(response.data);

      if (Array.isArray(response.data)) {
        //trace.information("BuscarPaquetes", response.data);
        dispatch(cargarPaginacion(response.data));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarPrestaciones", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });
};

export const NuevaPrestacion = () => (dispatch) => {
  dispatch(cargarNuevaPrestacion(true));
  dispatch(LimpiarPrestacion());
};

export const CerrarNuevaPrestacion = () => (dispatch) => {
  dispatch(cargarNuevaPrestacion(false));
};

export const obtenerCentrosAtencionAll = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/centroatencion/prestadorAll/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerCentrosAtencion", json);
        // dispatch(...);
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerCentrosAtencion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los centros de atención:",
        error,
      ));
    });
};

export const obtenerTiposAtencion = () => (dispatch) => {
  //trace.information("obtenerTiposAtencion [Se carga la función ObtenerTiposAtencion]");
  const globalState = store.getState().global;
  const params = {
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/paquetes/caracteristicas/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerTiposAtencion", json);
        dispatch(cargarTiposAtencion(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerTiposAtencion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los tipos de atención:",
        error,
      ));
    });
};

export const BuscarBorradorSolicitud = () => (dispatch) => {
  const globalState = store.getState().global;
  const estSol = 6; // borrador
  const tipSol = 0;
  // const fecSol = null;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutUsuario: globalState.rutUsuario,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  if (estSol && estSol !== 0 && estSol !== "0") {
    params.EstadoSolicitud = estSol;
  }
  if (tipSol && tipSol !== 0 && tipSol !== "0") {
    params.TipoSolicitud = tipSol;
  }
  // if (fecSol && fecSol !== 0 && fecSol !== "0" && fecSol !== null) { params.FechaSolicitud = fecSol; }

  // console.log("PARAMS TO SEARCH BORRADOR:", params);

  fetch(`${apiConfig.apiUri}/v1/solicitudes/searchBorrador`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("BuscarBorradorSolicitud", json);
        dispatch(CargarSolicitudes(json));
        if (json.length > 0) {
          dispatch(GetDetalleSolicitud(json[0].IdSolicitud));
        }
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("BuscarBorradorSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar borrador solicitudes:",
        error,
      ));
    });
};

export const ValidarPrestacionesSolicitudEnCurso = (callbackExisteSolicitud, callbackNoExisteSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const grillaSolicitudState = store.getState().grillaSolicitudPQ;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    Prestaciones: [],
    token: globalState.token,
  };
  for (let i = 0; i < grillaSolicitudState.prestacionesSolicitud.length; i += 1) {
    params.Prestaciones.push({
      ID_PAQUETE: grillaSolicitudState.prestacionesSolicitud[i].idPaqueteEditar,
      PAQU_CODIGO: grillaSolicitudState.prestacionesSolicitud[i].paqueteEditar.PAQU_CODIGO,
    });
  }
  fetch(`${apiConfig.apiUri}/v1/paquetes/ExisteDetalleSolicitudEnCurso/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("ValidarSolicitudEnCurso", result);
    if (result.filter((r) => r.ExisteEnCurso).length > 0) {
      dispatch(SetSolicitudesEnCurso(true, result));
      dispatch(nuevaSolicitud(null));
      if (callbackExisteSolicitud) {
        callbackExisteSolicitud(result);
      }
    } else {
      dispatch(SetSolicitudesEnCurso(false, null));
      if (callbackNoExisteSolicitud) {
        callbackNoExisteSolicitud();
      }
    }
  }), (error) => {
    trace.error("ValidarSolicitudEnCurso", error);
  });
};

export const GetDetalleSolicitud = (idSolicitud) => (dispatch) => {
  // const filtroBusquedaSRState = store.getState().filtroBusquedaSR;
  // const solicitud = filtroBusquedaSRState.solicitudes.filter((s) => s.IdSolicitud === idSolicitud)[0];
  // dispatch(CargarDetalleSolicitudCabecera(solicitud));

  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/solicitudes/GetDetalleSolicitud`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("GetDetalleSolicitud", json);
        dispatch(CargarDetalleSolicitud(json, idSolicitud));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("GetDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar el detalle de la solicitud:",
        error,
      ));
    });
};

export const deleteBorrador = (idSolicitud, rutPrestador, PrutInstitucion, Isapre) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    rutPrest: rutPrestador,
    rutInstitucion: PrutInstitucion,
    isapre: Isapre,
    token: globalState.token,
    rutUsuario: globalState.rutUsuario,
    idSolicitud,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/deleteBorrador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },

    credentials: "same-origin",
    body: JSON.stringify(params),

  }).then((res) => res.json().then((result) => {
    //trace.information("deleteBorrador", result);
    dispatch(OpenCargarBorrador());
  }), (error) => {
    trace.error("deleteBorrador", error);
  });
};


export const GetSolicitudesExcel = () => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaPQ.filtros;
  const globalState = store.getState().global;
  let FechaInicioVigencia;

  if (filtrosState.inicioVigenciaPaquete) {
    FechaInicioVigencia = filtrosState.inicioVigenciaPaquete.getFullYear() * 1e4 + (filtrosState.inicioVigenciaPaquete.getMonth() + 1) * 100 + filtrosState.inicioVigenciaPaquete.getDate() + '';
  }

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    CodigoIntervencion: filtrosState.codIntervencion,
    CodPaquetePres: filtrosState.codPaquetePres,
    Descripcion: filtrosState.glosa,
    Vigencia: filtrosState.vigencia,
    FiltrosBusqueda: filtrosState.tipoAtencion3,
    FechaInicioVigencia: FechaInicioVigencia,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  axios.post(`${apiConfig.apiUri}/v1/paquetes/prestacionesExcel/`, { data: JSON.stringify(params) }, { responseType: "blob" })
    .then((response) => {
      if (response.status !== 200) {
        throw response.data;
      }
      dispatch(LoadingExcel(false));
      download(response.data, `paquetes_${(new Date()).toLocaleDateString()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }).catch((error) => {
      dispatch(LoadingExcel(false));
      trace.error("GetSolicitudesExcel", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener el archivo de las prestaciones:",
        error,
      ));
    });

  // fetch(`${apiConfig.apiUri}/v1/prestaciones/prestadorExcel/`, {
  //   method: "POST",
  //   headers: {
  //     // "Content-Type": "application/json",
  //     // Authorization: localStorage.getItem('id_token'),
  //   },
  //   credentials: "same-origin",
  //   body: JSON.stringify(params),
  //   timeout: 0,
  // })
  //   .then((response) => {
  //     if (!response.ok) {
  //       throw response;
  //     }
  //     return response.blob();
  //   })
  //   .then((blob) => {
  //     console.log("RESPONSE BLOB");
  //     console.log(blob);
  //     dispatch(LoadingExcel(false));
  //     download(blob, `prestaciones_${(new Date()).toLocaleDateString()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
  //   })
  //   .catch((error) => {
  //     dispatch(LoadingExcel(false));
  //     trace.error("GetSolicitudesExcel", error);
  //     dispatch(ErrorSnacktOpen(
  //       "Error al obtener GetSolicitudesExcel:",
  //       error,
  //     ));
  //   });
};
